import { render } from "./TheProfessionalHomeExpedients.vue?vue&type=template&id=38a67d5f&scoped=true&ts=true"
import script from "./TheProfessionalHomeExpedients.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalHomeExpedients.vue?vue&type=script&lang=ts"

import "./TheProfessionalHomeExpedients.vue?vue&type=style&index=0&id=38a67d5f&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a67d5f"]])

export default __exports__